var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasPermissionEx("view") }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPermissionEx("view"),
              expression: "hasPermissionEx('view')"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.orderNumber")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("SMS.pleaseEnterText")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleFilter($event)
                                }
                              },
                              model: {
                                value: _vm.queryParameter.orderNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "orderNo", $$v)
                                },
                                expression: "queryParameter.orderNo"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.$store.getters.isAdmin
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("SMS.agentId")) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "filter-item",
                                    attrs: {
                                      placeholder: _vm.$t("SMS.pleaseChoose"),
                                      clearable: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.queryParameter.agentId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.queryParameter,
                                          "agentId",
                                          $$v
                                        )
                                      },
                                      expression: "queryParameter.agentId"
                                    }
                                  },
                                  _vm._l(_vm.agentOption, function(item) {
                                    return _c("el-option", {
                                      key: item.agentId,
                                      attrs: {
                                        label: item.agentName,
                                        value: item.agentId
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$store.getters.isMerchant
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("SMS.organizationName")) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "filter-item",
                                    attrs: {
                                      placeholder: _vm.$t("SMS.pleaseChoose"),
                                      clearable: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value:
                                        _vm.queryParameter.organizationCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.queryParameter,
                                          "organizationCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryParameter.organizationCode"
                                    }
                                  },
                                  _vm._l(_vm.organizationOption, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.organizationCode,
                                      attrs: {
                                        label: item.organizationName,
                                        value: item.organizationCode
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "agentAmountChangeRecord.reasonForChangeInAmount"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.amountChangeReason,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "amountChangeReason",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "queryParameter.amountChangeReason"
                                }
                              },
                              _vm._l(_vm.amountChangeReasonOption, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.statisticsDate")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "filter-item",
                              attrs: {
                                title: _vm.$t("SMS.statisticsDate"),
                                clearable: "",
                                type: "datetimerange",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                "range-separator": "-",
                                "start-placeholder": _vm.$t("common.fromTime"),
                                "end-placeholder": _vm.$t("common.toTime")
                              },
                              model: {
                                value: _vm.queryParameter.timeList,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "timeList", $$v)
                                },
                                expression: "queryParameter.timeList"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              type: "info",
                              plain: _vm.$store.getters.plainConf,
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "div",
                    { staticClass: "otherActions" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            type: "info",
                            plain: _vm.$store.getters.plainConf,
                            icon: "el-icon-view"
                          },
                          on: { click: _vm.getStatistic }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("SMS.statistic")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasExportPermission,
                              expression: "hasExportPermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            type: "info",
                            plain: _vm.$store.getters.plainConf,
                            icon: "el-icon-download"
                          },
                          on: { click: _vm.handleExportReport }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("SMS.export")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "addEditOrDelete" })
                ]),
                _vm._v(" "),
                _vm.viewSummary
                  ? _c("summary-popup", {
                      attrs: { "data-list": _vm.summaryList }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "div",
                    { staticClass: "otherActions" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("audit"),
                              expression: "hasPermissionEx('audit')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            type: "success",
                            plain: _vm.$store.getters.plainConf,
                            icon: "el-icon-success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleAudit("Approve")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.auditApproveText")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("audit"),
                              expression: "hasPermissionEx('audit')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            type: "danger",
                            plain: _vm.$store.getters.plainConf,
                            icon: "el-icon-error"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleAudit("Refuse")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.auditRefuseText")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPermissionEx("view"),
                        expression: "hasPermissionEx('view')"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "45" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "ID",
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.id
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.id))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("order.order_no"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.orderNo
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.orderNo))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    this.$store.getters.isAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.agentId"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content:
                                            _vm.$t("agent.agentLabel") +
                                            "：" +
                                            _vm.convertAgentNameByAgentId(
                                              scope.row.agentId
                                            ) +
                                            " ，" +
                                            _vm.$t("agent.agentIdText") +
                                            "：" +
                                            scope.row.agentId
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.convertAgentNameByAgentId(
                                                  scope.row.agentId
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2004529040
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.$store.getters.isAdmin || this.$store.getters.isAgent
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.organizationName"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content:
                                            _vm.$t(
                                              "organization.organizationNameText"
                                            ) +
                                            "：" +
                                            _vm.convertOrganizationNameByOrganizationCode(
                                              scope.row.organizationCode
                                            ) +
                                            " ，" +
                                            _vm.$t(
                                              "organization.organizationCodeText"
                                            ) +
                                            ":" +
                                            scope.row.organizationCode
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.convertOrganizationNameByOrganizationCode(
                                                  scope.row.organizationCode
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            214640494
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "agentAmountChangeRecord.reasonForChangeInAmount"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertAmountChangeReasonOptionByKey(
                                      scope.row.amountChangeReason
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertAmountChangeReasonOptionByKey(
                                            scope.row.amountChangeReason
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "agentAmountChangeRecord.effectiveAmountBeforeOperation"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      scope.row.processInitAvailableAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processInitAvailableAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "agentAmountChangeRecord.changeEffectiveAmount"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      scope.row.processChangeAvailableAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processChangeAvailableAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "agentAmountChangeRecord.effectiveAmountAfterOperation"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      scope.row.processFinalAvailableAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processFinalAvailableAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "agentAmountChangeRecord.amountToBeCreditedBeforeOperation"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      scope.row.processInitUncreditedAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processInitUncreditedAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "agentAmountChangeRecord.changesToTheAmountToBeRecorded"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      scope.row.processChangeUncreditedAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row
                                            .processChangeUncreditedAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "agentAmountChangeRecord.amountToBeCreditedAfterOperation"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      scope.row.processFinalUncreditedAmount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processFinalUncreditedAmount
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.date"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.dateFormat(
                                      scope.row.createTime
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(scope.row.createTime)
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermissionEx("view"),
                      expression: "hasPermissionEx('view')"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.queryParameter.pageNum,
                    limit: _vm.queryParameter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }